export { default } from './Collapse';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Collapse/index.js
// module id = 231
// module chunks = 2